import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/api";
import { Trophy, ChevronLeft } from "lucide-react";

export default function RankingPublico() {
  const [dados, setDados] = useState({ ranking: [], totalArrecadado: 0 });
  useEffect(() => {
    (async () => {
      const { data } = await api.get("/publico/ranking");
      setDados(data || { ranking: [] });
    })();
  }, []);

  return (
    <div className="min-h-screen bg-superficie-base text-white py-12 px-6" data-testid="pagina-ranking-publico">
      <div className="max-w-5xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-white mb-6" data-testid="link-voltar-portal">
          <ChevronLeft className="w-4 h-4" /> Voltar
        </Link>
        <div className="flex items-center gap-3 mb-2">
          <Trophy className="w-5 h-5 text-amarelobrasil" />
          <span className="text-xs font-bold uppercase tracking-[0.3em] text-amarelobrasil">Classificação Pública</span>
        </div>
        <h1 className="font-heading uppercase text-5xl font-bold mb-8">Ranking Geral</h1>

        {dados.ranking.length === 0 ? (
          <div className="surface-card rounded-2xl p-10 text-center text-white/50">
            Ainda sem ranking. Aguarde os primeiros resultados.
          </div>
        ) : (
          <div className="surface-card rounded-2xl overflow-hidden">
            <table className="w-full text-sm">
              <thead className="bg-white/5 text-[10px] uppercase tracking-widest text-white/50 font-bold">
                <tr>
                  <th className="px-4 py-3 text-left">#</th>
                  <th className="px-4 py-3 text-left">Apostador</th>
                  <th className="px-4 py-3 text-right">Pontos</th>
                  <th className="px-4 py-3 text-right hidden md:table-cell">Exatos</th>
                  <th className="px-4 py-3 text-right hidden md:table-cell">Brasil</th>
                  <th className="px-4 py-3 text-right hidden md:table-cell">Prêmio</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-white/5">
                {dados.ranking.map((r, i) => (
                  <tr key={r.usuarioId} data-testid={`pub-ranking-${i+1}`}>
                    <td className="px-4 py-3 font-heading font-black tabular-nums w-12 text-white/40">
                      {String(i + 1).padStart(2, "0")}
                    </td>
                    <td className="px-4 py-3 font-bold">{r.usuario?.nomePublico || r.usuario?.nomeCompleto}</td>
                    <td className="px-4 py-3 text-right font-heading font-black text-amarelobrasil tabular-nums">{r.pontuacaoTotal}</td>
                    <td className="px-4 py-3 text-right tabular-nums hidden md:table-cell">{r.totalPlacaresExatos}</td>
                    <td className="px-4 py-3 text-right tabular-nums hidden md:table-cell">{r.totalPlacaresExatosBrasil}</td>
                    <td className="px-4 py-3 text-right tabular-nums hidden md:table-cell">
                      {r.valorPremiacaoPrevista ? `R$ ${Number(r.valorPremiacaoPrevista).toFixed(2)}` : "—"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
